import { render, staticRenderFns } from "./Vehiculos.vue?vue&type=template&id=67f22652"
import script from "./Vehiculos.vue?vue&type=script&lang=js"
export * from "./Vehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports